import _ from 'lodash';

export const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((word, index) => {
      if (index === 0 || index === 1) {
        return word[0];
      }
      return '';
    })
    .filter((letter) => letter)
    ?.join('');
};

export const toSentenceCase = (str: string) => {
  if (!str) return str;

  return str
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
    .trim() // Trim leading and trailing spaces
    .toLowerCase() // Convert entire string to lowercase
    .replace(/^\w/, (char) => char.toUpperCase()); // Capitalize only the first letter of the first word
};

export const emailToName = (email: string): string =>
  _.chain(email)
    .split('@')
    .head()
    .split('.')
    .map(_.capitalize)
    .join(' ')
    .value();
